import { EnvEnum } from "@/src/enums/common";

export type FeatureToggleEnvType = Record<EnvEnum, boolean>;
export type FeatureToggleType = boolean | FeatureToggleEnvType;

export enum FeatureToggle {
  EnableApiDebug = "enable-api-debug",
  ServerLogger = "server-logger",
  EnableUiDebug = "enable-ui-debug",
  ActivityHistory = "activity-history",
  FactualCreativeEnrichment = "factual-creative-enrichment",
  EnrichmentFlowConfiguration = "enrichment-flow-configuration",
  BulkImportEmptyValue = "bulk-import-empty-value",
  AiEnrichmentReview = "ai-enrichment-review",
  ImportAttributeOptionsSmartImport = "import-attribute-options-smart-import",
  AllowAttributeTypeChange = "allow-attribute-type-change",
  HomepageDashboard = "homepage-dashboard",
  SmartUploadTaskNotification = "smart-upload-task-notification",
  ProductPageRefactor = "product-page-refactor",
  EnrichmentEmtpyAttribute = "enrichment-empty-attribute",
  ImporterParentInfer = "importer-parent-infer",
  PdpNavigation = "pdp-navigation",
}

export const featureToggleConfig: Record<FeatureToggle, FeatureToggleType> = {
  [FeatureToggle.EnableApiDebug]: {
    [EnvEnum.DEV]: true,
    [EnvEnum.QA]: true,
    [EnvEnum.STAGING]: true,
    [EnvEnum.PRODUCTION]: false,
  },
  [FeatureToggle.ServerLogger]: {
    [EnvEnum.DEV]: false,
    [EnvEnum.QA]: true,
    [EnvEnum.STAGING]: true,
    [EnvEnum.PRODUCTION]: true,
  },
  [FeatureToggle.EnableUiDebug]: {
    [EnvEnum.DEV]: false,
    [EnvEnum.QA]: false,
    [EnvEnum.STAGING]: false,
    [EnvEnum.PRODUCTION]: false,
  },
  [FeatureToggle.ActivityHistory]: {
    // BE API not ready even before v2. Hence will remain OFF.
    [EnvEnum.DEV]: false,
    [EnvEnum.QA]: false,
    [EnvEnum.STAGING]: false,
    [EnvEnum.PRODUCTION]: false,
  },
  [FeatureToggle.FactualCreativeEnrichment]: {
    [EnvEnum.DEV]: false,
    [EnvEnum.QA]: false,
    [EnvEnum.STAGING]: false,
    [EnvEnum.PRODUCTION]: false,
  },
  [FeatureToggle.EnrichmentFlowConfiguration]: {
    [EnvEnum.DEV]: true,
    [EnvEnum.QA]: true,
    [EnvEnum.STAGING]: true,
    [EnvEnum.PRODUCTION]: false, // INTERNAL FEATURE, Remains OFF in PROD
  },
  [FeatureToggle.BulkImportEmptyValue]: {
    [EnvEnum.DEV]: true,
    [EnvEnum.QA]: true,
    [EnvEnum.STAGING]: false,
    [EnvEnum.PRODUCTION]: false,
  },
  [FeatureToggle.AiEnrichmentReview]: {
    [EnvEnum.DEV]: true,
    [EnvEnum.QA]: true,
    [EnvEnum.STAGING]: false,
    [EnvEnum.PRODUCTION]: false,
  },
  [FeatureToggle.ImportAttributeOptionsSmartImport]: {
    [EnvEnum.DEV]: false,
    [EnvEnum.QA]: false,
    [EnvEnum.STAGING]: false,
    [EnvEnum.PRODUCTION]: false,
  },
  [FeatureToggle.AllowAttributeTypeChange]: {
    [EnvEnum.DEV]: true,
    [EnvEnum.QA]: true,
    [EnvEnum.STAGING]: true,
    [EnvEnum.PRODUCTION]: true,
  },
  [FeatureToggle.HomepageDashboard]: {
    [EnvEnum.DEV]: true,
    [EnvEnum.QA]: true,
    [EnvEnum.STAGING]: true,
    [EnvEnum.PRODUCTION]: true,
  },
  [FeatureToggle.SmartUploadTaskNotification]: {
    [EnvEnum.DEV]: true,
    [EnvEnum.QA]: true,
    [EnvEnum.STAGING]: true,
    [EnvEnum.PRODUCTION]: false,
  },
  [FeatureToggle.ProductPageRefactor]: {
    [EnvEnum.DEV]: true,
    [EnvEnum.QA]: true,
    [EnvEnum.STAGING]: true,
    [EnvEnum.PRODUCTION]: true,
  },
  [FeatureToggle.EnrichmentEmtpyAttribute]: {
    [EnvEnum.DEV]: false,
    [EnvEnum.QA]: false,
    [EnvEnum.STAGING]: false,
    [EnvEnum.PRODUCTION]: false,
  },
  [FeatureToggle.ImporterParentInfer]: {
    [EnvEnum.DEV]: true,
    [EnvEnum.QA]: false,
    [EnvEnum.STAGING]: false,
    [EnvEnum.PRODUCTION]: false,
  },
  [FeatureToggle.PdpNavigation]: {
    [EnvEnum.DEV]: false,
    [EnvEnum.QA]: false,
    [EnvEnum.STAGING]: false,
    [EnvEnum.PRODUCTION]: false,
  },
};
